import { forwardRef, useImperativeHandle } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { addressConfirmationErrorMsg, addressConfirmationMsg, t } from '../../common/i18n/index.js';
import { CheckboxWithError } from '../../common/react-hook-form/fields/CheckboxWithError.js';

interface AddressConfirmationFormValues {
  addressChecked: boolean;
}

export interface AddressConfirmationRef {
  triggerValidation: () => Promise<boolean>;
}

export const DeviceCheckoutAddressConfirmation = forwardRef<
  AddressConfirmationRef,
  {
    setRefCallback?: (key: string, ref: HTMLElement | null) => void;
  }
>(({ setRefCallback }, ref) => {
  const methods = useForm<AddressConfirmationFormValues>({
    defaultValues: { addressChecked: false },
    mode: 'all',
  });

  // Using handleSubmit instead of trigger() because handleSubmit sets
  // formState.isSubmitted, which CheckboxWithError needs to display errors.
  useImperativeHandle(
    ref,
    () => ({
      triggerValidation: async () => {
        let isValid = false;
        await methods.handleSubmit(
          () => {
            isValid = true;
          },
          () => {}
        )();
        return isValid;
      },
    }),
    [methods]
  );

  return (
    <div
      id="addressChecked"
      ref={(element: HTMLElement | null) => {
        setRefCallback?.('addressChecked', element);
      }}
    >
      <FormProvider {...methods}>
        <CheckboxWithError
          name="addressChecked"
          label={t.T9V1(addressConfirmationMsg)}
          errorText={t.WTWB(addressConfirmationErrorMsg)}
        />
      </FormProvider>
    </div>
  );
});
